import AuthService from "../../utilities/services/auth.service";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { SeasonPackagesWrapper } from "../../components";

export default function SeasonPackagesPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <PaginationProvider>
      <ModalProvider>
        <SeasonPackagesWrapper organization={organization} />
      </ModalProvider>
    </PaginationProvider>
  );
}
